import React from "react";
import Section from "./Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "./SectionHeader";
import Clients from "./Clients";

function ComingSoon() {
  return (
    // bg="light"
    // textColor="dark"
    // size="md"
    // bgImage=""
    // bgImageOpacity={1}
    // title="You're in good company"
    // subtitle=""
    <Section
    //   bg="light"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={0}
    >
      <Container className="text-center">
        <SectionHeader
          title={"Coming Soon"}
          subtitle={"We're working on this behind the scenes. We'll let you know when it goes live!"}
          size={2}
          spaced={true}
        ></SectionHeader>
        {/* <Clients
          items={[
            {
              name: "Instagram",
              image: "https://uploads.divjoy.com/logo-instagram.svg",
              width: "150px"
            },
            {
              name: "Slack",
              image: "https://uploads.divjoy.com/logo-slack.svg",
              width: "135px"
            },
            {
              name: "Tinder",
              image: "https://uploads.divjoy.com/logo-tinder.svg",
              width: "90px"
            },
            {
              name: "Spotify",
              image: "https://uploads.divjoy.com/logo-spotify.svg",
              width: "135px"
            }
          ]}
        ></Clients> */}
      </Container>
    </Section>
  );
}

export default ComingSoon;